/* eslint-disable max-len */
import { KeyDict } from '@/types'
import { HexCode } from '../types'

export const KISWE_COLORS: KeyDict<(HexCode|null)[]> = {
  defaults: [
    '#DE2A1D', '#EB872A', '#FEFE41', '#66FA36', '#66F8FB', '#0E00F7', '#E62BFB', '#74167A', '#90673E', '#FFFFFF', '#808080', '#000000'
  ],
  grayscale: [
    null, '#FEFEFE', '#E6E6E6', '#CDCDCD', '#B4B4B4', '#9A9A9A', '#818181', '#676767', '#4C4C4C', '#343434', '#1A1A1A', '#000000'
  ],
  grid: [
    '#10273C', '#091443', '#0C002C', '#1E032B', '#270B16', '#430A08', '#411809', '#41280C', '#3F300A', '#4F4F14', '#3E4211', '#212F12',
    '#193B4D', '#0F1F61', '#12043E', '#2F0944', '#3B0F1C', '#63140D', '#61220D', '#5E3B13', '#5F4812', '#787420', '#5D661A', '#32441B',
    '#225A79', '#142C91', '#1C015F', '#450C62', '#5A152D', '#901E13', '#8F3215', '#8F5B1E', '#916821', '#B6AF2F', '#8E9A29', '#456428',
    '#2F789D', '#1B3CC1', '#26077F', '#5C1186', '#761F3C', '#C2261A', '#BB441C', '#BD7728', '#BF8F29', '#F0E941', '#B8C93A', '#618D36',
    '#388EC7', '#1F42F8', '#340B9F', '#7716A9', '#9A244B', '#E13C22', '#E75E22', '#EC9E30', '#EFBF34', '#F9FF53', '#D5EA4A', '#75AB44',
    '#4CB8EF', '#406EF2', '#460BDD', '#9D21E8', '#C83068', '#E95645', '#E87943', '#EEAA45', '#F4C24B', '#FBFC6B', '#E4EA6B', '#94CA5B',
    '#6BC9F6', '#6F90FA', '#6A34EB', '#B43EF1', '#D65F8A', '#EC7F72', '#EA9A6E', '#F0BF70', '#F5D771', '#FAFC96', '#E6F58A', '#AED881',
    '#95DAFB', '#A0B7F8', '#9A76F7', '#CC7DF9', '#E291AF', '#F1A6A1', '#F4BAA5', '#F6D49B', '#F7E29D', '#FBFAB7', '#EDF6AE', '#C7E1AE',
    '#C7EBFC', '#CEDAFC', '#CCBDF7', '#E4BBF8', '#F1C8DB', '#F0D5D2', '#FCD9D4', '#FAE9CC', '#FCF0CF', '#FCFFD7', '#F5FBD3', '#DBEAC9'
  ]
}
